var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('kendo-grid',{ref:"grid",attrs:{"data-source":_vm.TrackingPurchaseOrder,"filterable":_vm.filterableConfig,"sortable":true,"pageable":_vm.pageableConfig,"columns":_vm.columns,"resizable":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }